// extracted by mini-css-extract-plugin
export default {"milestoneLink":"MilestoneMetadata-module__milestoneLink--gnE34","milestoneTitleTruncate":"MilestoneMetadata-module__milestoneTitleTruncate--ZhflK"};